import { AmexIcon } from '@hyphengroup/cms-components/components/icons/AmexPayIcon';
import { ApplePayIcon } from '@hyphengroup/cms-components/components/icons/ApplePayIcon';
import AwardIcon from '@hyphengroup/cms-components/components/icons/AwardIcon';
import { GooglePayIcon } from '@hyphengroup/cms-components/components/icons/GogglePayIcon';
import { MastercardIcon } from '@hyphengroup/cms-components/components/icons/MastercardIcon';
import { NetsPayIcon } from '@hyphengroup/cms-components/components/icons/NETSPayIcon';
import { SamsungPayIcon } from '@hyphengroup/cms-components/components/icons/SamsungPayIcon';
import { VisaIcon } from '@hyphengroup/cms-components/components/icons/VisaIcon';
import React from 'react';
import BagIcon from '../icons/BagIcon';
import BigEqualIcon from '../icons/BigEqualIcon';
import CartIcon from '../icons/CartIcon';
import ChecklistIcon from '../icons/ChecklistIcon';
import CreditCardIcon from '../icons/CreditCardIcon';
import { HCarInsuranceIcon } from '../icons/HCarInsuranceIcon';
import { HCreditCardsIcon } from '../icons/HCreditCardsIcon';
import { HHomeInsuranceIcon } from '../icons/HHomeInsuranceIcon';
import { HInvestmentsIcon } from '../icons/HInvestmentsIcon';
import { HMaidInsuranceIcon } from '../icons/HMaidInsuranceIcon';
import { HPersonalLoansIcon } from '../icons/HPersonalLoansIcon';
import { HPriorityBankingIcon } from '../icons/HPriorityBankingIcon';
import { HSavingAccountsIcon } from '../icons/HSavingAccountsIcon';
import { HTravelInsuranceIcon } from '../icons/HTravelInsuranceIcon';
import MoneyBoxIcon from '../icons/MoneyBoxIcon';
import MoneyIcon from '../icons/MoneyIcon';
import SearchShieldIcon from '../icons/SearchShieldIcon';
import WheelIcon from '../icons/WheelIcon';
import {
  Enum_Componentpagescomponentheaderwithtabstab_Icon,
  EnumIcon,
} from '$/(cms)/_modules/cmsService/types';

export const enum IconPay {
  AmericanExpress = 'AmericanExpress',
  Visa = 'Visa',
  SamsungPay = 'SamsungPay',
  ApplePay = 'ApplePay',
  GooglePay = 'GooglePay',
  Mastercard = 'Mastercard',
  NetsPay = 'NetsPay',
}

interface IconProps<T> extends React.SVGProps<SVGSVGElement> {
  icon: T;
}

const ICON_MAP: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  // EnumIcon mappings
  [EnumIcon.Award]: AwardIcon,
  [EnumIcon.Bag]: BagIcon,
  [EnumIcon.BigEqual]: BigEqualIcon,
  [EnumIcon.Cart]: CartIcon,
  [EnumIcon.Checklist]: ChecklistIcon,
  [EnumIcon.CreditCard]: CreditCardIcon,
  [EnumIcon.Money]: MoneyIcon,
  [EnumIcon.MoneyBox]: MoneyBoxIcon,
  [EnumIcon.SearchShield]: SearchShieldIcon,
  [EnumIcon.Wheel]: WheelIcon,

  // IconPay mappings
  [IconPay.AmericanExpress]: AmexIcon,
  [IconPay.GooglePay]: GooglePayIcon,
  [IconPay.Mastercard]: MastercardIcon,
  [IconPay.NetsPay]: NetsPayIcon,
  [IconPay.SamsungPay]: SamsungPayIcon,
  [IconPay.Visa]: VisaIcon,
  [IconPay.ApplePay]: ApplePayIcon,

  // HOME_ICON_MAP mappings
  [Enum_Componentpagescomponentheaderwithtabstab_Icon.CarInsurance]:
    HCarInsuranceIcon,
  [Enum_Componentpagescomponentheaderwithtabstab_Icon.CreditCards]:
    HCreditCardsIcon,
  [Enum_Componentpagescomponentheaderwithtabstab_Icon.HomeInsurance]:
    HHomeInsuranceIcon,
  [Enum_Componentpagescomponentheaderwithtabstab_Icon.Investments]:
    HInvestmentsIcon,
  [Enum_Componentpagescomponentheaderwithtabstab_Icon.MaidInsurance]:
    HMaidInsuranceIcon,
  [Enum_Componentpagescomponentheaderwithtabstab_Icon.PersonalLoans]:
    HPersonalLoansIcon,
  [Enum_Componentpagescomponentheaderwithtabstab_Icon.PriorityBanking]:
    HPriorityBankingIcon,
  [Enum_Componentpagescomponentheaderwithtabstab_Icon.SavingAccounts]:
    HSavingAccountsIcon,
  [Enum_Componentpagescomponentheaderwithtabstab_Icon.TravelInsurance]:
    HTravelInsuranceIcon,
};

type PropsEnum =
  | Enum_Componentpagescomponentheaderwithtabstab_Icon
  | IconPay
  | EnumIcon;

export const Icon: React.FC<IconProps<PropsEnum>> = ({ icon, ...svgProps }) => {
  const IconComponent = ICON_MAP[icon];
  return IconComponent ? <IconComponent {...svgProps} /> : null;
};
